import { Uzivatel } from "b2b/renderers/ciselnik";

export const jmeno = () => ({
  id: "jmeno",
  label: "b2b.uzivatele-grid-columns.jmeno.label",
  path: "",
  renderer: Uzivatel
});

export const telefon = () => ({
  id: "telefon",
  label: "b2b.uzivatele-grid-columns.telefon.label",
  path: "telefon"
});

export const email = () => ({
  id: "email",
  label: "b2b.uzivatele-grid-columns.email.label",
  path: "email"
});

export const role = () => ({
  id: "role",
  label: "b2b.uzivatele-grid-columns.role.label",
  path: "role",
  renderer: ({ val }) => (val ? val.join(", ") : null)
});
